/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';
import _ from 'lodash';

const state = {
  currentProject: null,
  projectsById: {},
  projectIds: [],
  isEmptyProjects: true,
};

const getters = {
  currentProject: state => state.currentProject,
  currentProjectId: state => _.get(state, 'currentProject.projectId', null),
  getProjectById: state => projectId => state.projectsById[projectId],
  projectIds: state => state.projectIds,
  isEmptyProjects: state => state.isEmptyProjects,
};

const mutations = {
  setIsCurrentProjectLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setProjects(state, projects) {
    projects.forEach((project) => { Vue.set(state.projectsById, project.projectId, project); });
    state.projectIds = _.map(projects, project => project.projectId);
  },
  setCurrentProject(state, currentProject) {
    state.currentProject = _.cloneDeep(currentProject);
  },
  setIsEmptyProject(state, isEmptyProjects) {
    state.isEmptyProjects = isEmptyProjects;
  },
  addProject(state, newProject) {
    Vue.set(state.projectsById, newProject.projectId, newProject);
    state.projectIds.push(newProject.projectId);
  },
  updateProject(state, projectData) {
    Vue.delete(state.projectIds, state.projectIds.indexOf(projectData.projectId));
    state.projectIds.push(projectData.projectId);
    // update currentProject too
    if (projectData.projectId === state.currentProject.projectId) {
      state.currentProject = _.cloneDeep(projectData);
    }
  },
  destoryCurrentProject(state) {
    state.currentProject = null;
  },
};

const actions = {
  setProjects({ commit }, projects) {
    commit('setProjects', projects);
    // set flag empty state
    if (projects && projects.length > 0) {
      commit('setIsEmptyProject', false);
    }
  },
  setCurrentProject({ commit }, currentProject) {
    commit('setCurrentProject', currentProject);
  },
  addProject({ commit }, newProject) {
    commit('addProject', newProject);
    commit('setIsEmptyProject', false);
  },
  updateProject({ commit }, payload) {
    commit('updateProject', payload);
  },
  destoryCurrentProject({ commit }) {
    commit('destoryCurrentProject');
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
